import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, ButtonProps } from '@material-ui/core';
import { RootState } from 'interfaces';
import NewChecklistDialog from 'pages/PageChecklistRegister/components/NewChecklistDialog';

// Пропсы принимаем и прокидываем в Button: ButtonGroup клонирует прямых детей
// и передаёт им className с классами группы — на нём и держатся радиусы крайних кнопок.
const CreateCheckListButton = (props: ButtonProps) => {
  const user = useSelector((state: RootState) => state.user);
  const [opened, setOpened] = useState<boolean>(false);

  return (
    <>
      <Button
        {...props}
        style={{ backgroundColor: '#27AE60', color: 'inherit', ...props.style }}
        variant="contained"
        onClick={() => setOpened(true)}
      >
        Создать чек-лист
      </Button>

      <NewChecklistDialog
        open={opened}
        onClose={() => setOpened(false)}
        userPhoneNumber={user && user.telephoneNumber ? user.telephoneNumber : ''}
        title="Добавить чек-лист"
        onSave={() => setOpened(false)}
      />
    </>
  );
};

export default CreateCheckListButton;
